import { UserType } from "models/Auth";

/**
 * @param {string} email 이메일 정규식 유효성 검사
 * @returns {boolean}
 */
export const isValidEmail = (email: string) => {
  return (
    email.match(
      /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,4}$/i
    ) !== null
  );
};

export const isValidPassword = (password: string) => {
  return password.match(/^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,25}$/);
};

/**
 * @param {string} phoneNumber 전화번호 정규식 유효성 검사
 * @returns {boolean}
 */
export const isValidPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.match(/^01(?:0|1|[6-9])-(?:\d{3}|\d{4})-\d{4}$/);
};

/**
 * @param {string} input 전화번호 형식으로 정규식 변환
 * @returns {string|undefined}
 */
export const formatPhoneNumber = (input?: string) => {
  return input
    ?.replace(/[^0-9]/g, "")
    .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
    .replace(/(-{1,2})$/g, "");
};

export const getUserInfo = (): {
  userType: UserType;
  userId: number;
  email: string;
} | null => {
  const userInfoValue = window.localStorage.getItem("userInfo");

  if (!userInfoValue) return null;

  const userInfo = JSON.parse(userInfoValue);
  return userInfo;
};

export const clearUser = () => {
  window.localStorage.removeItem("userInfo");
  window.localStorage.removeItem("accessToken");
  window.localStorage.removeItem("refreshToken");
  window.localStorage.removeItem("signupStatus");
};

export const getIsUser = () => {
  return window.localStorage.getItem("accessToken") &&
    window.localStorage.getItem("signupStatus") === "APPROVED"
    ? true
    : false;
};
